<template>
  <div>
    <right-panel class="float-right" :id="id" width="600px" @hidden="rightPanelClosed">
      <content-loading v-if="!atLeastShow" />

      <div v-if="atLeastShow" class="pl-5 pr-5">
        <!---->
        <h5>
          {{ $t("inventory.filter.plural") }}
        </h5>

        <h6 class="mb-0 mt-2 text-muted">{{ $t("department.text") }}</h6>
        <filter-select
          id="departmentFilter"
          ref="departmentFilter"
          :multiple="true"
          :selected="criteria.department"
          @filter="onDepartmentSearch"
          @changed="onDepartmentSelect"
          :placeholder="$t('common.choose')"
        />

        <h6 class="mb-0 mt-2 text-muted">{{ $t("process.text") }}</h6>
        <filter-select
          id="processFilter"
          ref="processFilter"
          :multiple="true"
          :selected="criteria.process"
          @filter="onProcessSearch"
          @changed="onProcessSelect"
          :placeholder="$t('common.choose')"
        />

        <h6 class="mb-0 mt-2 text-muted">{{ $t("data-category.text") }}</h6>
        <filter-select
          id="dataCategoryFilter"
          ref="dataCategoryFilter"
          :multiple="true"
          :selected="criteria.dataCategory"
          @filter="onDataCategorySearch"
          @changed="onDataCategorySelect"
          :placeholder="$t('common.choose')"
        />

        <h6 class="mb-0 mt-2 text-muted">{{ $t("data.text") }}</h6>
        <filter-select
          id="dataFilter"
          ref="dataFilter"
          :multiple="true"
          :selected="criteria.data"
          @filter="onDataSearch"
          @changed="onDataSelect"
          :placeholder="$t('common.choose')"
        />

        <h6 class="mb-0 mt-2 text-muted">{{ $t("datasubject.text") }}</h6>
        <filter-select
          id="datasubjectFilter"
          ref="datasubjectFilter"
          :multiple="true"
          :selected="criteria.datasubject"
          @filter="onDatasubjectSearch"
          @changed="onDatasubjectSelect"
          :placeholder="$t('common.choose')"
        />

        <h4 class="mt-4 text-muted">
          {{ $t("thirdparty.text") }}
        </h4>

        <h6 class="mb-0 mt-2 text-muted">{{ $t("receiver-group.text") }}</h6>
        <filter-select
          id="receiverGroupFilter"
          ref="receiverGroupFilter"
          :multiple="true"
          :selected="criteria.receiverGroup"
          @filter="onReceiverGroupSearch"
          @changed="onReceiverGroupSelect"
          :placeholder="$t('common.choose')"
        />

        <h6 class="mb-0 mt-2 text-muted">{{ $t("thirdparty.direction") }}</h6>
        <select v-model="thirdPartyDirection" @change="onAbroadChanged" class="form-control form-control-sm">
          <option value="NONE">{{ $t("thirdparty.none") }}</option>
          <option value="EXPORT">{{ $t("thirdparty.export") }}</option>
          <option value="IMPORT">{{ $t("thirdparty.import") }}</option>
          <option value="BOTH">{{ $t("thirdparty.both") }}</option>
        </select>

        <h6 class="mb-0 mt-2 text-muted">
          {{ $t("thirdparty.text") }}

          <label class="float-right">
            {{ $t("thirdparty.only-abroad") }}
            <input v-model="abroad" @change="onAbroadChanged" type="checkbox" />
          </label>
        </h6>
        <filter-select
          id="thirdPartyFilter"
          ref="thirdPartyFilter"
          :multiple="true"
          :selected="criteria.thirdParty"
          @filter="onThirdPartySearch"
          @changed="onThirdPartySelect"
          :placeholder="$t('common.choose')"
        />

        <h4 class="mt-4 text-muted">
          {{ $t("inventory.filter.inventory-features") }}
        </h4>

        <h6 class="mb-0 mt-2 text-muted">{{ $t("direct-collect-method.text") }}</h6>
        <filter-select
          id="directCollectFilter"
          ref="directCollectFilter"
          :multiple="true"
          :selected="criteria.directCollectMethod"
          @filter="onDirectCollectMethodSearch"
          @changed="onDirectCollectMethodSelect"
          :placeholder="$t('common.choose')"
        />

        <h6 class="mb-0 mt-2 text-muted">{{ $t("other-collect-method.text") }}</h6>
        <filter-select
          id="otherCollectFilter"
          ref="otherCollectFilter"
          :multiple="true"
          :selected="criteria.otherCollectMethod"
          @filter="onOtherCollectMethodSearch"
          @changed="onOtherCollectMethodSelect"
          :placeholder="$t('common.choose')"
        />

        <h6 class="mb-0 mt-2 text-muted">{{ $t("physical-storage.text") }}</h6>
        <filter-select
          id="physicalStorageFilter"
          ref="physicalStorageFilter"
          :multiple="true"
          :selected="criteria.physicalStorage"
          @filter="onPhysicalStorageSearch"
          @changed="onPhysicalStorageSelect"
          :placeholder="$t('common.choose')"
        />

        <h6 class="mb-0 mt-2 text-muted">{{ $t("electronic-storage.text") }}</h6>
        <filter-select
          id="electronicStorageFilter"
          ref="electronicStorageFilter"
          :multiple="true"
          :selected="criteria.electronicStorage"
          @filter="onElectronicStorageSearch"
          @changed="onElectronicStorageSelect"
          :placeholder="$t('common.choose')"
        />

        <sweet-button @click="apply()" variant="success" icon="bx bx-check" size="sm" buttonClass="mt-2 mb-5">
          {{ $t("common.ok") }}
        </sweet-button>

        <sweet-button @click="clear()" variant="secondary" icon="bx bx-x" size="sm" buttonClass="mt-2 float-right">
          {{ $t("common.clear") }}
        </sweet-button>
        <!---->
      </div>
    </right-panel>
    <!---->
    <!-- <sweet-button v-if="hasFilter" @click="clear()" variant="light" icon="bx bx-x" size="sm" buttonClass="mt-2 mr-2">
      {{ $t("inventory.filter.clear") }}
    </sweet-button> -->
    <sweet-button @click="toggleSidebar()" variant="info" icon="mdi mdi-filter" size="sm" buttonClass="mt-2 mr-2">
      {{ $t("inventory.filter.text") }}
    </sweet-button>
  </div>
</template>

<script>
import { datasOfNodes } from "@/modules/process-data/info-row";
const hasAnyValue = (value) => {
  if (!value) return false;
  if (Array.isArray(value)) {
    return value.length > 0;
  }
  return !!value;
};

export default {
  props: ["id", "multipleFields"],
  computed: {
    multipleList() {
      return this.multipleFields ?? [];
    },
    criteria() {
      return this.$store.getters["legalDocumentFilter/criteria"];
    },
    hasFilter() {
      return Object.keys(this.criteria).find((i) => !!this.criteria[i]);
    },

    abroad: {
      get() {
        return this.$store.getters["legalDocumentFilter/abroad"];
      },
      set(v) {
        this.$store.commit("legalDocumentFilter/abroad", !this.criteria.abroad);
      },
    },
    thirdPartyDirection: {
      get() {
        return this.$store.getters["legalDocumentFilter/thirdPartyDirection"];
      },
      set(v) {
        this.$store.commit("legalDocumentFilter/thirdPartyDirection", v);
      },
    },
  },

  data() {
    return { atLeastShow: false };
  },

  methods: {
    async onDepartmentSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationDepartment/paginate`, {
        options: { limit: 1000 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onDepartmentSelect(item) {
      this.$store.commit("legalDocumentFilter/department", item);
      this.$refs.processFilter.reset();
    },

    //Process
    async onProcessSearch(value, callback) {
      if (hasAnyValue(this.criteria.department)) {
        const response = await this.$store.dispatch(`organizationDepartmentProcess/paginate`, {
          options: { limit: 1000 },
          query: { name: { value }, department: { value: this.criteria.department.map((i) => i._id), isObject: true } },
        });

        callback(response.data?.docs ?? []);
      } else {
        const response = await this.$store.dispatch(`organizationProcess/paginate`, {
          options: { limit: 1000 },
          query: { name: { value } },
        });

        callback(response.data?.docs ?? []);
      }
    },
    onProcessSelect(item) {
      this.$store.commit("legalDocumentFilter/process", item);
      this.$refs.dataCategoryFilter.reset();
    },
    //Datacategory
    async onDataCategorySearch(value, callback) {
      const response = await this.$store.dispatch(`organizationDataCategory/paginate`, {
        options: { limit: 1000 },
        query: { name: { value } },
      });
      callback(response.data?.docs ?? []);
    },
    onDataCategorySelect(item) {
      this.$store.commit("legalDocumentFilter/dataCategory", item);
      this.$refs.dataFilter.reset();
    },

    //Data
    async onDataSearch(value, callback) {
      // TKP-27 / 6.4c-1: birim ve süreç seçiliyse süreçlerin düğümlerindeki veriler (kaynak seviyesi yok); kriter organizasyon verisi
      if (hasAnyValue(this.criteria.department) && hasAnyValue(this.criteria.process)) {
        const response = await this.$store.dispatch(`organizationProcessData/paginate`, {
          options: { limit: 1000 },
          query: { name: { value }, process: { value: this.criteria.process.map((i) => i._id), isObject: true } },
        });
        callback(datasOfNodes(response.data?.docs ?? [], this.criteria.dataCategory));
      } else {
        const response = await this.$store.dispatch(`organizationData/paginate`, {
          options: { limit: 1000 },
          query: { name: { value } },
        });
        callback(response.data?.docs ?? []);
      }
    },
    onDataSelect(item) {
      this.$store.commit("legalDocumentFilter/data", item);
      this.$refs.datasubjectFilter.reset();
    },

    //Datasubject
    async onDatasubjectSearch(value, callback) {
      // Kriter organizasyon ilgili kişisi; hiyerarşi daraltmasını backend düğümden yapar (6.4c-1)
      const response = await this.$store.dispatch(`organizationDatasubject/paginate`, {
        options: { limit: 1000 },
        query: { name: { value } },
      });
      callback(response.data?.docs ?? []);
    },
    onDatasubjectSelect(item) {
      this.$store.commit("legalDocumentFilter/datasubject", item);
    },

    //DirectCollectMethod
    async onDirectCollectMethodSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationDirectCollectMethod/paginate`, {
        options: { limit: 1000 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onDirectCollectMethodSelect(item) {
      this.$store.commit("legalDocumentFilter/directCollectMethod", item);
    },

    //OtherCollectMethod
    async onOtherCollectMethodSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationOtherCollectMethod/paginate`, {
        options: { limit: 1000 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onOtherCollectMethodSelect(item) {
      this.$store.commit("legalDocumentFilter/otherCollectMethod", item);
    },

    //PhysicalStorage
    async onPhysicalStorageSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationPhysicalStorage/paginate`, {
        options: { limit: 1000 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onPhysicalStorageSelect(item) {
      this.$store.commit("legalDocumentFilter/physicalStorage", item);
    },

    onPhysicalStoragePeriod($e) {
      const value = $e.target.value;
      this.$store.commit("legalDocumentFilter/physicalStoragePeriod", value);
    },

    onElectronicStoragePeriod($e) {
      const value = $e.target.value;
      this.$store.commit("legalDocumentFilter/electronicStoragePeriod", value);
    },

    //ElectronicStorage
    async onElectronicStorageSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationElectronicStorage/paginate`, {
        options: { limit: 1000 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onElectronicStorageSelect(item) {
      this.$store.commit("legalDocumentFilter/electronicStorage", item);
    },

    //ReceiverGroup
    async onReceiverGroupSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationReceiverGroup/paginate`, {
        options: { limit: 1000 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onReceiverGroupSelect(item) {
      this.$store.commit("legalDocumentFilter/receiverGroup", item);
      this.$refs.thirdPartyFilter.reset();
    },
    onAbroadChanged() {
      this.$refs.thirdPartyFilter.reset();
    },
    //ThirdParty
    async onThirdPartySearch(value, callback) {
      const query = { name: { value } };

      if (hasAnyValue(this.criteria.receiverGroup)) {
        query.receiverGroup = { value: this.criteria.receiverGroup.map((i) => i._id), isObject: true };
      }
      if (this.abroad) {
        query.abroad = { value: true, isObject: true };
      }
      if (this.thirdPartyDirection) {
        query.direction = { value: this.thirdPartyDirection, isObject: true };
      }

      const response = await this.$store.dispatch(`organizationThirdParty/paginate`, {
        options: { limit: 1000 },
        query,
      });

      callback(response.data?.docs ?? []);
    },
    onThirdPartySelect(item) {
      this.$store.commit("legalDocumentFilter/thirdParty", item);
    },

    //
    apply() {
      this.$emit("apply");
      this.toggleSidebar();
    },
    clear() {
      this.$store.commit("legalDocumentFilter/clear");
      if (this.atLeastShow) {
        this.$refs.departmentFilter.reset();
        this.$refs.processFilter.reset();
        this.$refs.dataCategoryFilter.reset();
        this.$refs.dataFilter.reset();
        this.$refs.datasubjectFilter.reset();
        this.$refs.directCollectFilter.reset();
        this.$refs.otherCollectFilter.reset();
        this.$refs.physicalStorageFilter.reset();
        this.$refs.electronicStorageFilter.reset();
        this.$refs.receiverGroupFilter.reset();
        this.$refs.thirdPartyFilter.reset();
      }

      this.$emit("apply");
    },

    toggleSidebar() {
      this.$root.$emit("bv::toggle::collapse", this.id);
      setTimeout(() => (this.atLeastShow = true), 100);
    },
    rightPanelClosed() {},
  },
};
</script>
